import React, {Component, Fragment} from 'react'
import Push from "push.js"
import Button from "@material-ui/core/Button"
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from '../../dialog'
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';

export const ALLOW_NOTIFICATIONS = 'allow-notifications'


class Notification extends Component {
    constructor(props) {
        super(props)
        this.notification = React.createRef()
        this.handleNotificationRequest = this.handleNotificationRequest.bind(this)
    }

    componentWillMount() {
        let notification = Push.Permission.get()
        this.setState({notification: notification})
    }


    handleNotificationRequest() {

        Push.Permission.request(
            () => {
                this.updateNotification("granted")
            },
            () => {
                this.updateNotification("denied")
            }
        )

        if(this.state.notification !== "default") {
            this.notification.current.handleClickOpen()
        }
    }

    /**
     * @param {boolean} value
     */
    updateNotification(value) {
        localStorage.setItem(ALLOW_NOTIFICATIONS, value)
        this.setState({
            notification: value
        })
    }

    render() {
        const {notification} = this.state
        return (
            <Fragment>
                {'Notification' in window && (
                    <Tooltip key={'notify'}
                             title={(notification === "default") ? "Permitir" : ((notification === "denied") ? "Inativo" : "Ativo")}
                             placement='bottom'>
                        <Button
                            onClick={() => this.handleNotificationRequest()}>
                            {(notification === "default") ? this.props.t.allowNotification : ((notification === "denied") ? this.props.t.inactiveNotification : this.props.t.activeNotification)}
                        </Button>

                    </Tooltip>
                )}
                <Dialog ref={this.notification}
                        title='Aviso'
                        text={this.props.t.messageActiveNotification}
                >
                </Dialog>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    t: state.i18nState.translations[state.i18nState.lang]['MenuNotification']['Content'],
})

export default connect(mapStateToProps)(withSnackbar(Notification))
